class Navigation {
  constructor() {
    this.menuIcon = document.querySelector('.menuIcon');
    this.menuContainer = document.querySelector('.menuContainer');
    this.menuOverlay = document.querySelector('.menu-overlay');
    this.closeMenu = document.querySelector('.close-menu');
    this.header = document.querySelector('header');

    if (this.menuIcon && this.menuContainer && this.menuOverlay && this.closeMenu) {
      this.initializeEventListeners();

    }
    
    // Initialize header color change on scroll
    this.initializeHeaderColorChange();
  }

  initializeEventListeners() {
    this.menuIcon.addEventListener('click', () => this.toggleMenu());
    this.closeMenu.addEventListener('click', () => this.closeMenuHandler());
    this.menuOverlay.addEventListener('click', () => this.closeMenuHandler());
    this.initializeSubmenuHandlers();
  }

  toggleMenu() {
    console.log('toggleMenu');
    this.menuContainer.classList.toggle('hidden');
    this.menuOverlay.classList.toggle('hidden');
    document.body.classList.toggle('overflow-hidden');
  }

  closeMenuHandler() {
    this.menuContainer.classList.add('hidden');
    this.menuOverlay.classList.add('hidden');
    document.body.classList.remove('overflow-hidden');
  }

  initializeSubmenuHandlers() {
    const menuLinks = document.querySelectorAll('.menuContainer > ul > li > a');
    menuLinks.forEach(link => {
      const submenu = link.parentElement.querySelector('div');
      if (submenu) {
        link.addEventListener('click', (e) => {
          if (window.innerWidth < 1024) { // Only for mobile
            e.preventDefault();
            this.handleSubmenuClick(submenu);
          }
        });
      }
    });

    // Handle back button clicks
    document.querySelectorAll('.back-button').forEach(button => {
      button.addEventListener('click', () => {
        const submenu = button.closest('div[class*="pointer-events-auto"]');
        if (submenu) {
          this.closeSubmenu(submenu);
        }
      });
    });
  }

  handleSubmenuClick(submenu) {
    // Close other open submenus
    document.querySelectorAll('.menuContainer div[class*="pointer-events-auto"]').forEach(menu => {
      if (menu !== submenu) {
        this.closeSubmenu(menu);
      }
    });
    // Toggle current submenu
    this.toggleSubmenu(submenu);
  }

  toggleSubmenu(submenu) {
    submenu.classList.toggle('pointer-events-auto');
    submenu.classList.toggle('block');
    submenu.classList.toggle('opacity-100');
    submenu.classList.toggle('pointer-events-none');
    submenu.classList.toggle('hidden');
    submenu.classList.toggle('opacity-0');
  }

  closeSubmenu(submenu) {
    submenu.classList.remove('pointer-events-auto', 'block', 'opacity-100');
    submenu.classList.add('pointer-events-none', 'hidden', 'opacity-0');
  }

  initializeHeaderColorChange() {
    if (this.header) {
      window.addEventListener('scroll', () => {
        if (window.scrollY > window.innerHeight * 0.8) {
          this.header.classList.add('!text-black');
        } else {
          this.header.classList.remove('!text-black');
        }
      });
    }
  }
}

// Initialize navigation when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new Navigation();
}); 